import { Action } from 'redux'
import { useDispatch } from 'react-redux'
import { RSAAAction } from 'redux-api-middleware'

import { RootState } from '../reducers'
import { store } from '../containers/Root'

export interface ApiCallType {
    request: string
    success: string
    failure: string
}

export interface ActionsTypes {
    [action: string]: ApiCallType
}

export type MetaAction<Type, Meta = void> = Action<Type> & { meta?: Meta }

export type PayloadAction<Type, Payload, Meta = void> = MetaAction<Type, Meta> & { readonly payload: Payload }

export const useAppDispatch = () => useDispatch<typeof store.dispatch>()

/**
 * @deprecated Use ThunkAction type below
 */
export type ThunkRSAAAction<
    R, // Return type of the thunk function
    A extends RSAAAction // Action types that will be passed to dispatch function
> = (dispatch: (action: A) => typeof store.dispatch, getState: () => RootState) => R

export type ThunkAction<
    R, // Return type of the thunk function
    A extends (Action | RSAAAction) // Action types that will be passed to dispatch function
> = (dispatch: (action: A) => typeof store.dispatch, getState: () => RootState) => R
